const PAGES = {
	es: "https://www.tu.biz/es/productos/hidraulicos/bombas/bombas_de_pistones/series_a10v_a4v",
	en: "https://www.tu.biz/en/products/hydraulics/pumps/piston_pumps/series_a10v_a4v",
};

/** PNG preview. WhatsApp does not show the catalog SVG. */
const A10V_SHARE_IMAGE = "https://www.tu.biz/images/1_op_images/a10v/a10v.png";
const A4V_SHARE_IMAGE = "https://www.tu.biz/images/1_op_images/a4v/a4v.png";

const SHARES = {
	es: {
		"serie-a10v": {
			title: "Bombas A10V A10VS018/31 a A10VS060/63/52/53",
			description: "Bombas de pistón A10V: A10VS018/31 a A10VS060/63/52/53.",
			image: A10V_SHARE_IMAGE,
		},
		"serie-a4v": {
			title: "Bombas A4V A4VSO40 a A4VSO355",
			description: "Bombas de pistón A4V: A4VSO40 a A4VSO355.",
			image: A4V_SHARE_IMAGE,
		},
	},
	en: {
		"a10v-series": {
			title: "A10V Piston Pumps A10VS018/31 to A10VS060/63/52/53",
			description: "A10V piston pumps: A10VS018/31 to A10VS060/63/52/53.",
			image: A10V_SHARE_IMAGE,
		},
		"a4v-series": {
			title: "A4V Piston Pumps A4VSO40 to A4VSO355",
			description: "A4V piston pumps: A4VSO40 to A4VSO355.",
			image: A4V_SHARE_IMAGE,
		},
	},
};

/**
 * Share preview for the A10V/A4V page.
 * WhatsApp reads the first HTML, so this must be chosen on the server from `open`.
 * The last series tab in the query wins. Applications can stay open beside it.
 * Each series uses its PNG in public/images/1_op_images.
 * Returns null when neither series tab is open (the combined page preview).
 * `locale` is "es" (serie-a10v / serie-a4v) or "en" (a10v-series / a4v-series).
 */
export function a10vShareFromOpen(open, locale = "es") {
	const raw = Array.isArray(open) ? open.join(",") : String(open || "");
	if (!raw) return null;
	let decoded = raw;
	try {
		decoded = decodeURIComponent(raw);
	} catch {
		decoded = raw;
	}
	const table = SHARES[locale] || SHARES.es;
	let series = null;
	for (const segment of decoded.split(/[,/]/)) {
		if (table[segment]) series = segment;
	}
	const share = series ? table[series] : null;
	if (!share) return null;
	const page = PAGES[locale] || PAGES.es;
	return {
		...share,
		ogURL: `${page}?open=${encodeURIComponent(decoded)}`,
	};
}
